import { PawPrint } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function ShopComingSoon() {
  return (
    <section id="merch" data-testid="shop-coming-soon" className="relative bg-sand py-20 sm:py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-2xl">
          <p className="eyebrow">Wag n Tails shop</p>
          <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl text-charcoal tracking-tight leading-snug">
            A Wag n Tails shop will be opening soon.
          </h2>
          <p className="mt-4 text-bark leading-relaxed">
            Tail-wagging tees, mugs and mountain gear are in the works — every purchase will go
            straight back into food, vet bills and cozy beds. The animals say stay tuned.
          </p>
          <div data-testid="shop-coming-soon-badge"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold/15 px-4 py-2 font-mono text-xs uppercase tracking-[0.2em] text-bark">
            <PawPrint className="h-4 w-4 text-gold" /> Opening soon
          </div>
        </Reveal>
      </div>
    </section>
  );
}
